import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import adminRoutes from './adminRoutes';
import partnerRoutes from './partnerRoutes';
import Layout from './Layout';
import AdminLogin from '../pages/AdminLogin';
import PartnerLogin from '../pages/PartnerLogin';
import NotFound from '../pages/NotFound';
import AuthService from '../services/AuthService';
import HomePage from '../pages/landing/HomePage';
import TermsCondition from '../pages/landing/TermsAndConditions';
import Privacy from '../pages/landing/PrivacyPolicy';
import CancellationPolicy from '../pages/landing/CancellationPolicy';
import BecomePartner from '../pages/landing/BecomePartner';

const AppRouter = () => {
    const isAdminAuthenticated = !!AuthService.getCurrentUser();
    const ispartnerAuthenticated = !!AuthService.getCurrentpartner();
    const basePath = process.env.REACT_APP_BASE_PATH;

    return (
        <Router basename={basePath}>
            <Routes>
                {/* Landing Website Routes */}
                <Route path="/" element={<HomePage />} />
                <Route path="/terms" element={<TermsCondition />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/cancellation-policy" element={<CancellationPolicy />} />
                <Route path="/become-partner" element={<BecomePartner />} />
                {/* <Route path="/" element={<Navigate to="/admin/dashboard" />} /> */}

                {/* Legacy redirect */}
                <Route path="/dashboard" element={<Navigate to="/admin/dashboard" />} />
                <Route path="/login" element={<Navigate to="/admin/login" />} />

                {/* Admin login */}
                <Route path="/admin/login" element={
                    <Layout hideHeader={true} hasPermission={true}>
                        <AdminLogin />
                    </Layout>
                } />

                {/* Partner login */}
                <Route path="/partner/login" element={
                    <Layout hideHeader={true} hasPermission={true} layoutType="partner">
                        <PartnerLogin />
                    </Layout>
                } />
                {/* Legacy redirect */}
                <Route path="/partner/login" element={<Navigate to="/partner/login" />} />

                {/* Admin portal routes */}
                <Route path="/admin" element={<Navigate to="/admin/dashboard" />} />
                {adminRoutes.map((route, index) => {
                    const Component = route.component;
                    return (
                        <Route
                            key={`admin-${index}`}
                            path={route.path}
                            element={
                                route.meta.requiresAuth && !isAdminAuthenticated ? (
                                    <Navigate to="/admin/login" />
                                ) : (
                                    <Layout hideHeader={false} hasPermission={true} layoutType="admin">
                                        <Component />
                                    </Layout>
                                )
                            }
                        />
                    );
                })}

                {/* Partner portal routes */}
                <Route path="/partner" element={<Navigate to="/partner/dashboard" />} />
                {partnerRoutes.map((route, index) => {
                    const Component = route.component;
                    return (
                        <Route
                            key={`partner-${index}`}
                            path={route.path}
                            element={
                                route.meta.requiresAuth && !ispartnerAuthenticated ? (
                                    <Navigate to="/partner/login" />
                                ) : (
                                    <Layout hideHeader={false} hasPermission={true} layoutType="partner">
                                        <Component />
                                    </Layout>
                                )
                            }
                        />
                    );
                })}

                {/* 404 */}
                <Route path="*" element={<NotFound />} />
            </Routes>
        </Router>
    );
};

export default AppRouter;
